import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ACTIVATION_PARAMETERS_FEATURE, activationParametersReducer } from './activation-parameters.reducer';
import { AngularSharedModule } from '../shared/angularShared/angularShared.module';
import { ActivationParametersService } from './activation-parameters.service';


@NgModule({
  declarations: [],
  imports: [
    AngularSharedModule,
    StoreModule.forFeature(ACTIVATION_PARAMETERS_FEATURE, activationParametersReducer),
  ],
  providers: [ActivationParametersService]
})
export class ActivationParametersModule { }
